const actions = {
  EMPLOYEE_DISCOUNT_MODEL_LIST_BEGIN: "EMPLOYEE_DISCOUNT_MODEL_LIST_BEGIN",
  EMPLOYEE_DISCOUNT_MODEL_LIST_SUCCESS: "EMPLOYEE_DISCOUNT_MODEL_LIST_SUCCESS",
  EMPLOYEE_DISCOUNT_MODEL_LIST_ERR: "EMPLOYEE_DISCOUNT_MODEL_LIST_ERR",
  EMPLOYEE_DISCOUNT_MODEL_LIST_RESET: "EMPLOYEE_DISCOUNT_MODEL_LIST_RESET",

  EMPLOYEE_DISCOUNT_CHECK_BEGIN: "EMPLOYEE_DISCOUNT_CHECK_BEGIN",
  EMPLOYEE_DISCOUNT_CHECK_SUCCESS: "EMPLOYEE_DISCOUNT_CHECK_SUCCESS",
  EMPLOYEE_DISCOUNT_CHECK_ERR: "EMPLOYEE_DISCOUNT_CHECK_ERR",
  EMPLOYEE_DISCOUNT_CHECK_RESET: "EMPLOYEE_DISCOUNT_CHECK_RESET",

  EMPLOYEE_DISCOUNT_WALLET_BALANCE_BEGIN:
    "EMPLOYEE_DISCOUNT_WALLET_BALANCE_BEGIN",
  EMPLOYEE_DISCOUNT_WALLET_BALANCE_SUCCESS:
    "EMPLOYEE_DISCOUNT_WALLET_BALANCE_SUCCESS",
  EMPLOYEE_DISCOUNT_WALLET_BALANCE_ERR: "EMPLOYEE_DISCOUNT_WALLET_BALANCE_ERR",

  EMPLOYEE_DISCOUNT_SUBMIT_BEGIN: "EMPLOYEE_DISCOUNT_SUBMIT_BEGIN",
  EMPLOYEE_DISCOUNT_SUBMIT_SUCCESS: "EMPLOYEE_DISCOUNT_SUBMIT_SUCCESS",
  EMPLOYEE_DISCOUNT_SUBMIT_ERR: "EMPLOYEE_DISCOUNT_SUBMIT_ERR",
  EMPLOYEE_DISCOUNT_SUBMIT_RESET: "EMPLOYEE_DISCOUNT_SUBMIT_RESET",

  EMPLOYEE_DISCOUNT_HISTORY_BEGIN: "EMPLOYEE_DISCOUNT_HISTORY_BEGIN",
  EMPLOYEE_DISCOUNT_HISTORY_SUCCESS: "EMPLOYEE_DISCOUNT_HISTORY_SUCCESS",
  EMPLOYEE_DISCOUNT_HISTORY_ERR: "EMPLOYEE_DISCOUNT_HISTORY_ERR",
  EMPLOYEE_DISCOUNT_HISTORY_RESET: "EMPLOYEE_DISCOUNT_HISTORY_RESET",

  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_BEGIN:
    "EMPLOYEE_DISCOUNT_HISTORY_DETAILS_BEGIN",
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_SUCCESS:
    "EMPLOYEE_DISCOUNT_HISTORY_DETAILS_SUCCESS",
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_ERR: "EMPLOYEE_DISCOUNT_HISTORY_DETAILS_ERR",
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_RESET:
    "EMPLOYEE_DISCOUNT_HISTORY_DETAILS_RESET",

  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_BEGIN:
    "EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_BEGIN",
  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_SUCCESS:
    "EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_SUCCESS",
  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_ERR:
    "EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_ERR",

  getEmployeeDiscountModelListBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_MODEL_LIST_BEGIN,
  }),

  getEmployeeDiscountModelListSuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_MODEL_LIST_SUCCESS,
    data,
  }),

  getEmployeeDiscountModelListErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_MODEL_LIST_ERR,
    err,
  }),

  getEmployeeDiscountModelListReset: () => ({
    type: actions.EMPLOYEE_DISCOUNT_MODEL_LIST_RESET,
  }),

  checkEmployeeDiscountBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_CHECK_BEGIN,
  }),

  checkEmployeeDiscountSuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_CHECK_SUCCESS,
    data,
  }),

  checkEmployeeDiscountErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_CHECK_ERR,
    err,
  }),

  checkEmployeeDiscountReset: () => ({
    type: actions.EMPLOYEE_DISCOUNT_CHECK_RESET,
  }),

  getEmployeeDiscountWalletBalanceBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_WALLET_BALANCE_BEGIN,
  }),

  getEmployeeDiscountWalletBalanceSuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_WALLET_BALANCE_SUCCESS,
    data,
  }),

  getEmployeeDiscountWalletBalanceErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_WALLET_BALANCE_ERR,
    err,
  }),

  submitEmployeeDiscountBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_SUBMIT_BEGIN,
  }),

  submitEmployeeDiscountSuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_SUBMIT_SUCCESS,
    data,
  }),

  submitEmployeeDiscountErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_SUBMIT_ERR,
    err,
  }),

  submitEmployeeDiscountReset: () => ({
    type: actions.EMPLOYEE_DISCOUNT_SUBMIT_RESET,
  }),

  getEmployeeDiscountHistoryBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_BEGIN,
  }),

  getEmployeeDiscountHistorySuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_SUCCESS,
    data,
  }),

  getEmployeeDiscountHistoryErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_ERR,
    err,
  }),

  getEmployeeDiscountHistoryReset: () => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_RESET,
  }),

  getEmployeeDiscountHistoryDetailsBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_DETAILS_BEGIN,
  }),

  getEmployeeDiscountHistoryDetailsSuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_DETAILS_SUCCESS,
    data,
  }),

  getEmployeeDiscountHistoryDetailsErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_DETAILS_ERR,
    err,
  }),

  getEmployeeDiscountHistoryDetailsReset: () => ({
    type: actions.EMPLOYEE_DISCOUNT_HISTORY_DETAILS_RESET,
  }),

  getEmployeeDiscountPurchaseHistoryBegin: () => ({
    type: actions.EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_BEGIN,
  }),

  getEmployeeDiscountPurchaseHistorySuccess: (data) => ({
    type: actions.EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_SUCCESS,
    data,
  }),

  getEmployeeDiscountPurchaseHistoryErr: (err) => ({
    type: actions.EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_ERR,
    err,
  }),
};

export default actions;
